export default __webpack_public_path__ + "static/media/python-advance.094771fd.png";